(function () {
  // Run as soon as DOM is ready — `detachEmpireSearchHandlers` polls until
  // Empire has actually attached its listeners, so there's no need to wait.
  var INIT_DELAY = 50;
  var SEARCH_SELECTOR = '[data-live-search]';
  var EXCLUDE_SELECTOR = '.mh-header';

  // ── Past Searches ──────────────────────────────────────────────────────────
  var PAST_KEY = 'mm_past_searches';
  var MAX_PAST = 5;

  var CLOCK_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>';
  var X_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
  var BOOK_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>';

  function getPastSearches() {
    try { return JSON.parse(localStorage.getItem(PAST_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function savePastSearch(query) {
    if (!query) return;
    query = query.trim();
    if (!query) return;
    try {
      var list = getPastSearches().filter(function (s) {
        return s.toLowerCase() !== query.toLowerCase();
      });
      list.unshift(query);
      localStorage.setItem(PAST_KEY, JSON.stringify(list.slice(0, MAX_PAST)));
    } catch (e) {}
  }

  function removePastSearch(query) {
    try {
      var list = getPastSearches().filter(function (s) {
        return s.toLowerCase() !== query.toLowerCase();
      });
      localStorage.setItem(PAST_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function escHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function renderPastSearches(quickLinksEl) {
    if (!quickLinksEl) return;

    var existing = quickLinksEl.querySelector('[data-past-searches-section]');
    if (existing) existing.remove();

    var searches = getPastSearches();
    if (!searches.length) return;

    var section = document.createElement('div');
    section.setAttribute('data-past-searches-section', '');
    section.className = 'search-flydown--past-searches';

    var html = '<span class="search-flydown--popular-title">Recent Searches</span>';
    html += '<ul class="search-flydown--past-searches-list">';
    searches.forEach(function (q) {
      var safe = escHtml(q);
      html += '<li class="search-flydown--past-searches-item">';
      html += '<a class="search-flydown--past-searches-link" href="/search?q=' + encodeURIComponent(q) + '">';
      html += '<span class="search-flydown--past-searches-icon">' + CLOCK_SVG + '</span>';
      html += '<span class="search-flydown--past-searches-text">' + safe + '</span>';
      html += '</a>';
      html += '<button class="search-flydown--past-searches-remove" type="button" data-remove-q="' + safe + '" aria-label="Remove recent search">' + X_SVG + '</button>';
      html += '</li>';
    });
    html += '</ul>';
    section.innerHTML = html;

    quickLinksEl.insertBefore(section, quickLinksEl.firstChild);

    section.querySelectorAll('[data-remove-q]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        removePastSearch(btn.getAttribute('data-remove-q'));
        renderPastSearches(quickLinksEl);
      });
    });
  }
  // ── End Past Searches ──────────────────────────────────────────────────────

  // Create overlay element for fullscreen search modal
  function createOverlay() {
    if (document.querySelector('.search-modal-overlay')) return;
    var overlay = document.createElement('div');
    overlay.className = 'search-modal-overlay';
    overlay.addEventListener('click', function () {
      if (isOverlayClickIgnored()) return;
      closeSearchModal();
    });
    document.body.appendChild(overlay);
  }

  var searchModalOpenedAt = 0;

  function openSearchModal() {
    document.body.classList.add('search-modal-active');
    searchModalOpenedAt = Date.now();
  }

  function closeSearchModal() {
    var wasActive = document.body.classList.contains('search-modal-active');
    document.body.classList.remove('search-modal-active');
    if (!wasActive) return;
    // Blur the search input
    var input = document.querySelector('.site-header-main [data-live-search-input]');
    if (input) input.blur();
  }

  function isOverlayClickIgnored() {
    return Date.now() - searchModalOpenedAt < 250;
  }

  function debounce(fn, wait) {
    var timeout = null;
    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }

  function shouldSkip(container, flydown) {
    if (!container || !flydown) return true;
    if (container.closest(EXCLUDE_SELECTOR)) return true;
    return false;
  }

  function ensureId(element, fallback) {
    if (!element) return '';
    if (!element.id) element.id = fallback;
    return element.id;
  }

  function ensureLiveSearchAccessibility(container, input, flydown, results) {
    var baseId = container.id || ('live-search-' + Math.random().toString(36).slice(2, 9));
    if (!container.id) container.id = baseId;
    ensureId(flydown, baseId + '-flydown');
    ensureId(results, baseId + '-results');

    var status = container.querySelector('[data-live-search-status]');
    if (!status) {
      status = document.createElement('div');
      status.className = 'visually-hidden';
      status.setAttribute('data-live-search-status', '');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      flydown.insertBefore(status, flydown.firstChild);
    }
    ensureId(status, baseId + '-status');

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', flydown.id);
    input.setAttribute('aria-describedby', status.id);
    if (!input.hasAttribute('aria-expanded')) {
      input.setAttribute('aria-expanded', 'false');
    }

    flydown.setAttribute('role', flydown.getAttribute('role') || 'region');
    flydown.setAttribute('aria-busy', 'false');
    results.setAttribute('role', results.getAttribute('role') || 'region');
    return status;
  }

  function setLiveSearchExpanded(input, expanded) {
    if (!input) return;
    input.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function announceLiveSearch(status, message) {
    if (!status) return;
    status.textContent = message || '';
  }

  // Empire's built-in LiveSearch uses jQuery namespaced events under `.live-search`.
  // We take ownership of search so we can apply caching, abort, stale-while-revalidate,
  // and search intelligence consistently. Detach Empire's slower handlers once it
  // has attached them — retry briefly in case Empire is still booting.
  function detachEmpireSearchHandlers(input, filter) {
    var attempts = 0;
    function attempt() {
      var $ = window.jQuery;
      if (!$) {
        if (attempts++ < 30) setTimeout(attempt, 100);
        return;
      }
      try {
        var events = $._data && $._data(input, 'events');
        var hasLiveSearch = events && (
          (events.keyup && events.keyup.some(function (h) { return h.namespace === 'live-search'; })) ||
          (events.focus && events.focus.some(function (h) { return h.namespace === 'live-search'; }))
        );
        if (hasLiveSearch) {
          $(input).off('.live-search');
          if (filter) $(filter).off('.live-search');
          return;
        }
      } catch (e) {}
      if (attempts++ < 30) setTimeout(attempt, 100);
    }
    attempt();
  }

  function dispatchSyntheticKeyup(input) {
    var keyupEvent;
    try {
      keyupEvent = new KeyboardEvent('keyup', { bubbles: true, cancelable: true });
    } catch (error) {
      keyupEvent = document.createEvent('Event');
      keyupEvent.initEvent('keyup', true, true);
    }
    input.dispatchEvent(keyupEvent);
  }

  function isMobileHeaderSearch(container) {
    if (!container || !container.closest('.site-header-main[data-site-header-mobile-search-bar]')) return false;
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function focusSearchInput(input) {
    if (!input || document.activeElement === input) return;
    try {
      input.focus({ preventScroll: true });
    } catch (e) {
      input.focus();
    }
  }

  function scheduleMobileHeaderSearchRefocus(container, input) {
    if (!isMobileHeaderSearch(container) || !input) return;

    function restore() {
      if (!isMobileHeaderSearch(container) || !input.isConnected) return;
      var active = document.activeElement;
      if (active === input) return;
      if (active && active instanceof Element && container.contains(active)) return;
      focusSearchInput(input);
    }

    window.requestAnimationFrame(restore);
    setTimeout(restore, 80);
    setTimeout(restore, 220);
  }

  // The native live-search opens mobile takeover only after terms exist.
  // For mobile search bar mode, trigger takeover + quick links on tap/focus.
  function setupMobileSearchTapOpen(container) {
    if (!container || container.dataset.mobileSearchTapOpen === 'true') return;
    if (!container.closest('.site-header-main[data-site-header-mobile-search-bar]')) return;

    var input = container.querySelector('[data-live-search-input]');
    if (!input) return;

    container.dataset.mobileSearchTapOpen = 'true';

    function isMobileViewport() {
      return window.matchMedia('(max-width: 767px)').matches;
    }

    function openTakeoverOnTap() {
      if (!isMobileViewport()) return;
      if (container.classList.contains('live-search--takeover')) return;
      if (input.value.trim().length > 0) return;
      dispatchSyntheticKeyup(input);
      scheduleMobileHeaderSearchRefocus(container, input);
    }

    input.addEventListener('focus', function () {
      setTimeout(function () {
        if (document.activeElement === input) {
          openTakeoverOnTap();
          scheduleMobileHeaderSearchRefocus(container, input);
        }
      }, 0);
    });
    input.addEventListener('click', function () {
      openTakeoverOnTap();
      scheduleMobileHeaderSearchRefocus(container, input);
    });
    input.addEventListener('touchend', function () {
      setTimeout(function () {
        openTakeoverOnTap();
        scheduleMobileHeaderSearchRefocus(container, input);
      }, 0);
    }, { passive: true });
  }

  function setupDesktopHeaderQuickLinks(container) {
    if (!container || container.dataset.desktopQuickLinksInit === 'true') return;
    if (!container.closest('.site-header-main')) return;
    if (!window.matchMedia('(min-width: 768px)').matches) return;

    var input = container.querySelector('[data-live-search-input]');
    var flydown = container.querySelector('[data-live-search-flydown]');
    var results = container.querySelector('[data-live-search-results]');
    var quickLinks = container.querySelector('[data-live-search-quick-links]');
    var placeholder = container.querySelector('[data-live-search-placeholder]');

    if (!input || !flydown || !quickLinks || !results) return;
    if (!quickLinks.children || quickLinks.children.length === 0) return;
    var status = ensureLiveSearchAccessibility(container, input, flydown, results);

    container.dataset.desktopQuickLinksInit = 'true';

    function updateFlydownHeight() {
      var flydownTop = flydown.getBoundingClientRect().top;
      var maxHeight = Math.max(220, window.innerHeight - flydownTop - 24);
      // Prefer whatever is currently visible so the flydown sizes to the
      // placeholder, results, or quick links — not just quick links.
      var visibleChild = flydown.querySelector(':scope > .visible');
      var contentHeight = visibleChild ? visibleChild.scrollHeight : quickLinks.scrollHeight;
      var nextHeight = Math.min(contentHeight, maxHeight);

      flydown.style.setProperty('--open-height', nextHeight + 'px');
      flydown.style.setProperty('--flydown-max-height', maxHeight + 'px');
    }

    function showQuickLinks() {
      if (input.value.trim()) return;

      if (placeholder) {
        placeholder.classList.remove('visible');
      }
      results.classList.remove('visible');
      results.dataset.animationState = 'hidden';
      quickLinks.classList.add('visible');
      quickLinks.dataset.animationState = 'visible';
      flydown.dataset.animationState = 'open';
      setLiveSearchExpanded(input, true);
      announceLiveSearch(status, 'Search suggestions available.');
      container.classList.add('live-search--active');
      updateFlydownHeight();
    }

    function hideQuickLinks() {
      quickLinks.classList.remove('visible');
      quickLinks.dataset.animationState = 'hidden';
      if (!results.classList.contains('visible')) {
        flydown.dataset.animationState = 'closed';
        flydown.style.setProperty('--open-height', '0px');
        setLiveSearchExpanded(input, false);
        announceLiveSearch(status, 'Search suggestions closed.');
        container.classList.remove('live-search--active');
      }
    }

    input.addEventListener('focus', showQuickLinks);
    input.addEventListener('click', showQuickLinks);
    input.addEventListener('input', function () {
      if (input.value.trim()) {
        // Synchronously swap from quick-links to placeholder so there is no
        // empty flash while the debounced search waits to fire. If results
        // are already visible (e.g. from a previous query / cache hit), we
        // leave them alone — setupContainer handles stale-while-revalidate.
        quickLinks.classList.remove('visible');
        quickLinks.dataset.animationState = 'hidden';
        var hasLiveResults = results.classList.contains('visible') && results.children.length > 0;
        if (!hasLiveResults && placeholder && !placeholder.classList.contains('visible')) {
          placeholder.classList.add('visible');
          flydown.dataset.animationState = 'open';
          container.classList.add('live-search--active');
          updateFlydownHeight();
        }
      } else {
        showQuickLinks();
      }
    });

    document.addEventListener('click', function (event) {
      if (!container.contains(event.target)) {
        hideQuickLinks();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        hideQuickLinks();
      }
    });

    window.addEventListener('resize', function () {
      if (quickLinks.classList.contains('visible')) {
        updateFlydownHeight();
      }
    });
  }

  // ── Ebook Guide Results ────────────────────────────────────────────────────
  function escHtmlAttr(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function injectEbookResults(resultsEl, query) {
    // Remove any previous ebook section
    var existing = resultsEl.querySelector('[data-ebook-guides]');
    if (existing) existing.remove();

    var ebookSearch = window.MrMapleEbookSearch;
    if (!ebookSearch) return;

    var matches = ebookSearch.search(query, 3);
    if (!matches.length) return;

    var ebookUrl = ebookSearch.getEbookUrl();

    var html = '<div class="search-flydown__ebook" data-ebook-guides>';
    html += '<div class="search-flydown__ebook-header">';
    html += '<span class="search-flydown__ebook-label">' + BOOK_SVG + ' Care Guides</span>';
    html += '<a class="search-flydown__ebook-all" href="' + escHtmlAttr(ebookUrl) + '">View all guides</a>';
    html += '</div>';
    html += '<ul class="search-flydown__ebook-list">';

    matches.forEach(function (guide) {
      var guideUrl = ebookSearch.getGuideUrl(guide.ebId);
      html += '<li class="search-flydown__ebook-item">';
      html += '<a class="search-flydown__ebook-link" href="' + escHtmlAttr(guideUrl) + '">';
      html += '<span class="search-flydown__ebook-name">' + escHtmlAttr(guide.title) + '</span>';
      html += '<span class="search-flydown__ebook-snippet">' + escHtmlAttr(guide.snippet) + '</span>';
      html += '</a>';
      html += '</li>';
    });

    html += '</ul>';
    html += '</div>';

    // Insert before the "View all results" button so it stays above the footer action
    var continueBtn = resultsEl.querySelector('.search-flydown__continue');
    if (continueBtn) {
      continueBtn.insertAdjacentHTML('beforebegin', html);
    } else {
      resultsEl.insertAdjacentHTML('beforeend', html);
    }
  }
  // ── End Ebook Guide Results ────────────────────────────────────────────────

  function setupContainer(container) {
    if (!container || container.dataset.liveSearchFallback === 'true') return;
    var input = container.querySelector('[data-live-search-input]');
    var flydown = container.querySelector('[data-live-search-flydown]');
    var results = container.querySelector('[data-live-search-results]');
    var placeholder = container.querySelector('[data-live-search-placeholder]');
    var quickLinks = container.querySelector('[data-live-search-quick-links]');
    var filter = container.querySelector('[data-live-search-filter]');
    var submit = container.querySelector('[data-live-search-submit]');

    if (!input || !flydown || !results) return;
    if (shouldSkip(container, flydown)) return;
    var status = ensureLiveSearchAccessibility(container, input, flydown, results);

    container.dataset.liveSearchFallback = 'true';

    // Take over from Empire's slower built-in handlers so this optimized flow owns search.
    detachEmpireSearchHandlers(input, filter);

    // ── Per-container state ─────────────────────────────────────────────────
    var CACHE_MAX = 50;
    var CACHE_TTL_MS = 5 * 60 * 1000;
    var resultsCache = new Map();
    var activeController = null;
    var lastFetchedQuery = '';
    var renderedKey = '';
    var searchIntelligence = window.MrMapleSearchIntelligence || null;

    function getCacheKey(query) {
      var prefix = filter && filter.value ? filter.value + '|' : '';
      return prefix + String(query || '').trim().toLowerCase();
    }

    function getSearchResultsUrl(query) {
      var form = input.form;
      var action = form && form.getAttribute('action') ? form.getAttribute('action') : '/search';
      var base = window.location.origin && window.location.origin !== 'null'
        ? window.location.origin
        : 'https://example.test';
      var url = new URL(action, base);
      var terms = String(query || '').trim();

      if (filter && filter.value) {
        terms = filter.value + ' AND ' + terms;
      }

      url.searchParams.set('q', terms);
      return url.pathname + url.search + url.hash;
    }

    function goToSearchResults(query) {
      var terms = String(query || '').trim();
      if (!terms) return false;

      savePastSearch(terms);
      window.location.href = getSearchResultsUrl(terms);
      return true;
    }

    function getCachedHtml(key) {
      var entry = resultsCache.get(key);
      if (!entry) return null;
      if (Date.now() - entry.ts > CACHE_TTL_MS) {
        resultsCache.delete(key);
        return null;
      }
      // LRU touch
      resultsCache.delete(key);
      resultsCache.set(key, entry);
      return entry.html;
    }

    function setCachedHtml(key, html) {
      if (resultsCache.size >= CACHE_MAX) {
        var firstKey = resultsCache.keys().next().value;
        resultsCache.delete(firstKey);
      }
      resultsCache.set(key, { html: html, ts: Date.now() });
    }

    function abortInFlight() {
      if (activeController) {
        try { activeController.abort(); } catch (e) {}
        activeController = null;
      }
    }

    function shouldUseHeaderOverlay() {
      if (!container.closest('.site-header-main')) return false;
      return !window.matchMedia('(max-width: 767px)').matches;
    }

    function setLoading(isLoading) {
      if (submit) {
        if (isLoading) {
          submit.classList.add('search-icon--processing');
          submit.setAttribute('disabled', '');
        } else {
          submit.classList.remove('search-icon--processing');
          submit.removeAttribute('disabled');
        }
      }
      // Subtle progress bar on the flydown so users get feedback without flicker
      flydown.classList.toggle('is-loading', !!isLoading);
      flydown.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      if (isLoading) {
        announceLiveSearch(status, 'Searching.');
      } else if (flydown.dataset.animationState === 'open') {
        setLiveSearchExpanded(input, true);
      }
    }

    function updateFlydownHeight() {
      var visible = flydown.querySelector(':scope > .visible');
      var scrollHeight = visible ? visible.scrollHeight : 0;
      flydown.style.setProperty('--open-height', scrollHeight + 'px');

      if (!visible) return;
      var viewportHeight = flydown.closest('[data-site-header]')
        ? document.documentElement.clientHeight
        : document.documentElement.scrollHeight;
      var topPos = visible.getBoundingClientRect().top + (flydown.closest('[data-site-header]') ? 0 : window.scrollY);
      var maxHeight = viewportHeight - topPos - 30;
      flydown.style.setProperty('--flydown-max-height', maxHeight + 'px');
    }

    function openFlydown() {
      flydown.dataset.animationState = 'open';
      setLiveSearchExpanded(input, true);
      container.classList.add('live-search--active');
      updateFlydownHeight();
    }

    function closeFlydown() {
      flydown.dataset.animationState = 'closed';
      setLiveSearchExpanded(input, false);
      container.classList.remove('live-search--active');
      results.classList.remove('visible', 'search-flydown--results--stale');
      results.dataset.animationState = 'closed';
      if (placeholder) placeholder.classList.remove('visible');
      if (quickLinks) {
        quickLinks.classList.remove('visible');
        quickLinks.dataset.animationState = 'closed';
      }
      flydown.style.setProperty('--open-height', '0px');
      setLoading(false);
      announceLiveSearch(status, 'Search suggestions closed.');
      renderedKey = '';
    }

    function showPlaceholder() {
      if (placeholder) placeholder.classList.add('visible');
      results.classList.remove('visible', 'search-flydown--results--stale');
      results.dataset.animationState = 'hidden';
      if (quickLinks) {
        quickLinks.classList.remove('visible');
        quickLinks.dataset.animationState = 'hidden';
      }
      openFlydown();
      announceLiveSearch(status, 'Searching.');
    }

    function showResults(opts) {
      opts = opts || {};
      if (placeholder) placeholder.classList.remove('visible');
      if (quickLinks) {
        quickLinks.classList.remove('visible');
        quickLinks.dataset.animationState = 'hidden';
      }
      results.classList.add('visible');
      results.classList.toggle('search-flydown--results--stale', !!opts.stale);
      results.dataset.animationState = 'visible';
      openFlydown();
      var resultCount = results.querySelectorAll('a[href]').length;
      announceLiveSearch(status, resultCount ? (resultCount + ' search results available.') : 'Search results updated.');
      scheduleMobileHeaderSearchRefocus(container, input);
    }

    function showQuickLinks() {
      if (!quickLinks) {
        closeFlydown();
        return;
      }
      renderPastSearches(quickLinks);
      if (placeholder) placeholder.classList.remove('visible');
      results.classList.remove('visible', 'search-flydown--results--stale');
      results.dataset.animationState = 'hidden';
      quickLinks.classList.add('visible');
      quickLinks.dataset.animationState = 'visible';
      openFlydown();
      announceLiveSearch(status, 'Search suggestions available.');
      scheduleMobileHeaderSearchRefocus(container, input);
    }

    function fetchResultsMarkup(query, opts) {
      opts = opts || {};
      var baseUrl = (window.Theme && window.Theme.routes && window.Theme.routes.predictive_search_url) || '/search/suggest';
      var url = baseUrl
        + '?q=' + encodeURIComponent(query)
        + '&resources[limit]=8'
        + '&resources[limit_scope]=each'
        + '&resources[options][unavailable_products]=last'
        + '&section_id=predictive-search';

      var init = {};
      if (!opts.skipAbort) {
        abortInFlight();
        activeController = new AbortController();
        init.signal = activeController.signal;
      }
      init.headers = { Accept: 'text/html' };
      // Hint high priority to the browser for snappier delivery (Chromium honors this).
      try { init.priority = 'high'; } catch (e) {}

      return fetch(url, init).then(function (response) {
        if (!response.ok) throw new Error(response.status);
        var contentType = response.headers && response.headers.get
          ? response.headers.get('content-type')
          : '';
        if (contentType && contentType.toLowerCase().indexOf('application/json') !== -1) {
          throw new Error('Search returned JSON instead of HTML');
        }
        return response.text();
      }).then(function (html) {
        var trimmed = String(html || '').trim();
        if (
          trimmed === '{}'
          || trimmed === '[]'
          || (trimmed.charAt(0) === '{' && trimmed.charAt(trimmed.length - 1) === '}')
          || (trimmed.charAt(0) === '[' && trimmed.charAt(trimmed.length - 1) === ']')
        ) {
          throw new Error('Search returned JSON instead of HTML');
        }
        return html;
      });
    }

    function renderResultsHtml(query, html) {
      results.innerHTML = html;
      document.dispatchEvent(new CustomEvent('mm:cards:added'));
      if (searchIntelligence) {
        try {
          searchIntelligence.clearPredictiveSuggestion(results);
          searchIntelligence.rerankPredictiveResults(results, query);
        } catch (e) {}
      }
      injectEbookResults(results, query);
      showResults();
      updateFlydownHeight();
      renderedKey = getCacheKey(query);
    }

    async function performSearch() {
      var terms = input.value.trim();

      if (!terms) {
        abortInFlight();
        setLoading(false);
        if (searchIntelligence) {
          try { searchIntelligence.clearPredictiveSuggestion(results); } catch (e) {}
        }
        if (quickLinks && quickLinks.children.length) {
          showQuickLinks();
        } else {
          closeFlydown();
        }
        renderedKey = '';
        lastFetchedQuery = '';
        return;
      }

      var key = getCacheKey(terms);

      // No-op if we already rendered this exact query
      if (key === renderedKey && !results.classList.contains('search-flydown--results--stale')) {
        setLoading(false);
        return;
      }

      // Cache hit: render instantly, no loading state, no fetch
      var cached = getCachedHtml(key);
      if (cached !== null) {
        abortInFlight();
        setLoading(false);
        renderResultsHtml(terms, cached);
        lastFetchedQuery = terms;
        return;
      }

      // Stale-while-revalidate: if we have previously rendered results, keep them
      // visible (dimmed) while we fetch — avoids flashing back to a skeleton.
      var hasVisibleResults = results.classList.contains('visible') && results.children.length > 0;
      if (hasVisibleResults) {
        results.classList.add('search-flydown--results--stale');
      } else {
        showPlaceholder();
      }
      setLoading(true);

      var fetchQuery = terms;
      if (filter && filter.value) {
        fetchQuery = filter.value + ' AND ' + terms;
      }

      try {
        var html = await fetchResultsMarkup(fetchQuery);
        // If the user kept typing and the value has moved on, drop this response.
        if (terms !== input.value.trim()) return;

        setCachedHtml(key, html);
        lastFetchedQuery = terms;
        renderResultsHtml(terms, html);

        // No product matches? Try a spell-corrected query in the background.
        if (
          searchIntelligence
          && !searchIntelligence.hasProductMatches(results)
          && (!filter || !filter.value)
        ) {
          var suggestion = await searchIntelligence.findSuggestion(terms);
          if (terms !== input.value.trim()) return;
          if (suggestion && suggestion.query) {
            var correctedKey = getCacheKey(suggestion.query);
            var correctedHtml = getCachedHtml(correctedKey);
            if (correctedHtml === null) {
              correctedHtml = await fetchResultsMarkup(suggestion.query, { skipAbort: true });
              if (terms !== input.value.trim()) return;
              setCachedHtml(correctedKey, correctedHtml);
            }
            results.innerHTML = correctedHtml;
            document.dispatchEvent(new CustomEvent('mm:cards:added'));
            try {
              searchIntelligence.rerankPredictiveResults(results, suggestion.query);
              var correctedHasProducts = searchIntelligence.hasProductMatches(results);
              searchIntelligence.injectPredictiveSuggestion(results, {
                originalQuery: terms,
                correctedQuery: suggestion.query,
                emptyResults: !correctedHasProducts,
              });
            } catch (e) {}
            injectEbookResults(results, terms);
            showResults();
            updateFlydownHeight();
          }
        }

        setLoading(false);
      } catch (error) {
        if (error && error.name === 'AbortError') return;
        setLoading(false);
        // Keep prior results visible if we have them — otherwise close.
        if (!hasVisibleResults) closeFlydown();
        else results.classList.remove('search-flydown--results--stale');
      }
    }

    var runSearch = debounce(performSearch, 110);

    input.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== 'Return') return;
      if (event.isComposing || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;

      event.preventDefault();
      if (!goToSearchResults(input.value)) return;

      abortInFlight();
      setLoading(false);
    });

    input.addEventListener('input', runSearch);
    input.addEventListener('focus', function () {
      var isHeaderSearch = container.closest('.site-header-main');
      var emptyInput = !input.value.trim();
      if (isHeaderSearch && emptyInput) {
        // Defer modal + flydown so the opening click completes before layout moves.
        // Otherwise the search box jumps to fixed position and mouseup lands on overlay, closing the modal.
        setTimeout(function () {
          if (document.activeElement !== input) return;
          if (shouldUseHeaderOverlay()) openSearchModal();
          if (quickLinks && quickLinks.children.length) {
            showQuickLinks();
          } else {
            closeFlydown();
          }
        }, 120);
      } else if (isHeaderSearch && !emptyInput) {
        setTimeout(function () {
          if (document.activeElement === input && shouldUseHeaderOverlay()) openSearchModal();
        }, 120);
        runSearch();
      } else {
        if (emptyInput) {
          if (quickLinks && quickLinks.children.length) {
            showQuickLinks();
          } else {
            closeFlydown();
          }
        } else {
          runSearch();
        }
      }
    });

    if (filter) {
      filter.addEventListener('change', function () {
        if (input.value.trim()) {
          runSearch();
        }
      });
    }

    // Cancel button handler
    var cancelBtn = container.querySelector('.live-search-takeover-cancel');
    if (cancelBtn) {
      cancelBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (shouldUseHeaderOverlay()) closeSearchModal();
        closeFlydown();
      });
    }

    // Save past search on form submit (Enter key / search button)
    if (input.form) {
      input.form.addEventListener('submit', function () {
        var q = input.value.trim();
        if (q) savePastSearch(q);
      });
    }

    // Save past search when user clicks a result link (not a past-search link itself)
    flydown.addEventListener('click', function (e) {
      var link = e.target.closest('a[href]');
      if (!link) return;
      if (link.closest('[data-past-searches-section]')) return;
      var q = input.value.trim();
      if (q) savePastSearch(q);
    });

    document.addEventListener('click', function (event) {
      var overlay = document.querySelector('.search-modal-overlay');
      if (!container.contains(event.target) && event.target !== overlay) {
        closeFlydown();
        // Only close modal if clicking outside search area
        if (!event.target.closest('.live-search') && shouldUseHeaderOverlay()) {
          closeSearchModal();
        }
      }
    });

    document.addEventListener('focusin', function (event) {
      if (!container.contains(event.target) && !event.target.closest('.search-modal-overlay')) {
        closeFlydown();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeFlydown();
        if (shouldUseHeaderOverlay()) closeSearchModal();
      }
    });

    window.addEventListener('resize', function () {
      if (flydown.dataset.animationState === 'open') {
        updateFlydownHeight();
      }
    });
  }

  function initFallback() {
    createOverlay();
    var containers = document.querySelectorAll(SEARCH_SELECTOR);
    if (!containers.length) return;
    containers.forEach(function (container) {
      setupMobileSearchTapOpen(container);
      setupDesktopHeaderQuickLinks(container);
      setupContainer(container);
    });
  }

  function scheduleInit() {
    setTimeout(initFallback, INIT_DELAY);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit);
  } else {
    scheduleInit();
  }
})();
